// import { Guid } from "@microsoft/sp-core-library";
import ContextService from "../../services/ContextService";
import axios from "axios";
import * as yup from "yup";
import { Web } from "sp-pnp-js";
import ActivityService from "../../services/ActivityService";
import SettingService from "../../services/SettingService";
import moment from "moment";
import { uuid } from "uuidv4";
import { useState } from "react";
import JSZip from "jszip";
import { finalactivitydata } from "./DefaultData";
import { AuthService } from "../../services/authService";

export const handleTokenExpiration = async <T = any>(
  retyFunction: () => Promise<T[]>
): Promise<T[]> => {
  try {
    const authService = new AuthService();
    await authService.initialize();
    const authResult = await getCurrentUserDetails(authService);
    const Token = authResult?.accessToken;

    if (Token) {
      localStorage.setItem("CurrentToken", Token);
      return await retyFunction();
    } else {
      return [];
    }
  } catch (error) {
    console.error("Token refresh failed:", error);
    return [];
  }
};
async function getCurrentUserDetails(authService): Promise<any> {
return new Promise(async (resolve, reject) => {
  try {
    const authResult = await authService.login();
    resolve(authResult);
  } catch (error) {
    console.error("Parent: Authentication failed", error);
    reject(error);
  }
});
}

export const fetchAppUsers=async ()=>{
    const token = localStorage.getItem("CurrentToken");
    const url = "/_api/web/lists/getbytitle('CLM365Users')/items?$select=*,UserStatus,GuidID,SPUser/Title,SPUser/ID,SPUser/EMail&$expand=SPUser";
    const allUsersOptions=[]
    try {
        const response = await axios.get(`${ContextService.GetUrl()}${url}`, {
            headers: {
              Accept: "application/json;odata=nometadata",
              "odata-version": "",
              Authorization: `Bearer ${token}`,
            },
          });
          const items=response?.data.value||[]
          items?.map((user)=>{
            allUsersOptions.push({
                key: user.email,
                text: user?.SPUser?.Title,
                id: user?.SPUser?.ID,
                userStatus:user?.UserStatus
            })
          })
          return allUsersOptions;
    } catch (error) {
      const status = error?.response?.status;
      if ([401, 402, 403].includes(status)) {
      return await handleTokenExpiration(fetchAppUsers);
    }
        return [];
    }
}
export const fetchRequestListData = async (hideSampleData): Promise<any[]> => {
  const token = localStorage.getItem("CurrentToken");
  const url = `/_api/web/lists/getbytitle('CLM365Request')/items?$top=5000&$select=*,ID,Title,Guid_ID,File_Name,Draft_Type,ActualFileName&$orderby=Created desc&$filter=Request_Type eq 'Contract' and ExecutionApproval ne 'Completed' and (Active eq 'Yes' or Active eq null)`;

  try {
    const response = await axios.get(
      `${ContextService.GetUrl()}${url}`, // Ensure the full URL is used
      {
        headers: {
          Accept: "application/json;odata=nometadata",
          "odata-version": "",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // console.log(response.data);
    const items = response.data?.value?.filter((i)=>i.ExecutionApproval !== 'Completed')
    const filterdItems = hideSampleData ? items?.filter(i=>i.SampleRequest !== 'Yes') : items || [];
    return filterdItems;
  } catch (error) {
    console.error("Error fetching data:", error);
    const status = error?.response?.status;
      if ([401, 402, 403].includes(status)) {
      return await handleTokenExpiration(() => fetchRequestListData(hideSampleData));
    }
    return [];
  }
};

export const fetchRequestData = async (guidId: string): Promise<any[]> => {
  const token = localStorage.getItem("CurrentToken");
  const url = `/_api/web/lists/getbytitle('CLM365Request')/items?$top=5000&$select=*,AttachmentFiles/FileName,AttachmentFiles&$expand=AttachmentFiles&$expand=AttachmentFiles&$orderby=Created desc&$filter=Guid_ID eq '${guidId}'`;

  try {
    const response = await axios.get(`${ContextService.GetUrl()}${url}`, {
      headers: {
        Accept: "application/json;odata=nometadata",
        "odata-version": "",
        Authorization: `Bearer ${token}`,
      },
    });

    // console.log(response.data); // Inspect the response to confirm structure

    // Check if 'value' exists in the response and return it
    const items = response.data?.value || [];
    return items;
  } catch (error) {
    console.error("Error fetching data:", error);
    return [];
  }
};



export const getAllContractNames = async (TempcurrentbusUnitName1, tempcontracttype) => {
  const token = localStorage.getItem("CurrentToken");
  const optionConName = [];
  try {
    const response = await axios.get(
      `${ContextService.GetUrl()}` +
        `/_api/web/lists/getbytitle('CLM365Contract_Type')/items?$top=5000&$select=ID,UserGroup,Guid_ID,ContractCode,ContractName`,
      {
        headers: {
          Accept: "application/json;odata=nometadata",
          "odata-version": "",
          Authorization: `Bearer ${token}`, // Include token for authentication
        },
      }
    );
    const items = response.data?.value || [];
    items.forEach((items: any) => {
      optionConName.push({
        key: items.ID,
        text: tempcontracttype[items.Guid_ID],
        label: tempcontracttype[items.Guid_ID],
        value: items.ID,
        code: items.ContractCode,
        guid: items.Guid_ID,
        UserGroup: JSON.parse(items?.UserGroup || "[]"),
      });
    });
    return optionConName;
  } catch {
    return [];
  }
};

export const getAllBusinussunitOptions = async (TempcurrentbusUnitName1) => {
  const token = localStorage.getItem("CurrentToken");
  const BusinessunitOptions = [];
  let activityLog = [];
  try {
    const response = await axios.get(
      `${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365General')/items?$select=ID,BusinessUnit,Activity&$filter=Title eq '${"GeneralData"}'`,
      {
        headers: {
          Accept: "application/json;odata=nometadata",
          "odata-version": "",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const items = response.data?.value || [];
    //   BusinessunitOptions = [];
    items.map((item) => {
      activityLog = JSON.parse(item.Activity || "[]");
      const businessunitArray = JSON.parse(item.BusinessUnit);
      businessunitArray?.map((curr, index) => {
        BusinessunitOptions.push({
          text: TempcurrentbusUnitName1[curr?.GUID],
          key: curr?.GUID,
          code: curr?.BusinessCode,
        });
      });
    });

    return { BusinessunitOptions, activityLog };
  } catch {
    return {};
  }
};

export async function getContractDetails(contractId, CurrentdisplayfieldsNameTemp, newColumn) {
  const token = localStorage.getItem("CurrentToken");
  let FileNames = [];
  let validateState = {};
  try {
    const response = await axios.get(
      `${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365Contract_Type')/items?$select=FormFields,ID,ConditionalField,DocumentTypeField,BusinessUnit,Attachments,AttachmentFiles,   
      BusinessUser/Id,BusinessUser/Title&$expand=BusinessUser,AttachmentFiles&$filter=(ID eq '` +
        contractId +
        `')`,
      {
        headers: {
          Accept: "application/json;odata=nometadata",
          "odata-version": "",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = response.data;

    FileNames.push(
      { key: "Blank", text: "Blank",value: "Blank", label: "Blank",  ServerRelativeUrl: "" },
      {
        key: "Attach your own file",
        text: "Attach your own file",
        value: "Attach your own file",
        label: "Attach your own file",
        ServerRelativeUrl: "",
      }
    );
    data.value[0]?.AttachmentFiles?.map((item) => {
      FileNames?.push({
        key: item?.FileName?.split(".")[0]?.replaceAll("_", " ") + ".docx",
        text: item?.FileName?.split(".")[0]?.replaceAll("_", " ") + ".docx",
        value: item?.FileName?.split(".")[0]?.replaceAll("_", " ") + ".docx",
        label: item?.FileName?.split(".")[0]?.replaceAll("_", " ") + ".docx",
        ServerRelativeUrl: item?.ServerRelativeUrl,
      });
    });
    FileNames = FileNames?.filter((obj, index) => {
      return index === FileNames?.findIndex((o) => obj.text === o.text);
    });

    const standardtemplatename = (data.value[0]?.AttachmentFiles[0]?.FileName)?.replaceAll("_", " ");

    const filepath = data.value[0]?.AttachmentFiles?.[0]?.ServerRelativeUrl ?? '';
    let _JsonFormFields = JSON.parse(data.value[0].FormFields);
    const GJsonFormFields = JSON.parse(data.value[0].FormFields);
    const GJsonFormFieldsCond = JSON.parse(data.value[0].ConditionalField);
    let _ConditionalField = JSON.parse(data.value[0].ConditionalField);
    // _ConditionalField f
    for (let sectionKey in _JsonFormFields) {
      const section = _JsonFormFields[sectionKey];

      section.items?.forEach((item) => {
        const matchingItem = newColumn?.find((col) => col.intName === item.IntName && col.type === "Choice");

        if (matchingItem && matchingItem.Choices) {
          item.Choices = matchingItem.Choices;
        }
      });
    }
    let _conditiondata = [];

    if (_JsonFormFields) {
      Object.entries(_JsonFormFields).forEach(([sectionKey, section]: any) => {
        section.items.forEach((item) => {
          if (item.Type === "Choice" && item.Choices && item.Choices.length > 0) {
            let _choiceoptions = item.Choices.map((choice) => ({
              key: choice,
              text: choice,
            }));

            let finalvalueuniq = Object.values(
              _choiceoptions.reduce((acc, cur) => Object.assign(acc, { [cur.key]: cur }), {})
            );

            _conditiondata.push({
              internalname: item.IntName,
              value: finalvalueuniq,
            });
          }
        });
      });
    }

    _JsonFormFields
      ? Object.entries(_JsonFormFields).map(([key1, column]: any, index: any) => {
          column.items.map((item: any, ind: any) => {
            if (item.Type == "Text" && item.Required == "Yes") {
              let reqmsg = "Please enter " + item.text.toLowerCase();
              let _reqfiled = yup.string().required(reqmsg);

              validateState = {
                ...validateState,
                [item.IntName]: _reqfiled,
              };
            }
            if (item.IntName == "Counterparty_Name" && item.Required == "Yes") {
              let reqmsg = "Please enter " + item.text.toLowerCase();
              let _reqfiled = yup.string().required(reqmsg);
              validateState = {
                ...validateState,
                [item.IntName]: _reqfiled,
              };
            }
            if (item.Type == "Note" && item.Required == "Yes") {
              let reqmsg = "Please enter " + item.text.toLowerCase();
              let _reqfiled = yup.string().required(reqmsg);
              validateState = {
                ...validateState,
                [item.IntName]: _reqfiled,
              };
            }
            if (item.Type == "DateTime" && item.Required == "Yes" && item.IntName !== "Contract_Date") {
              // let reqmsg = 'Please enter ' + (item.text).toLowerCase();
              const val = CurrentdisplayfieldsNameTemp?.[item?.IntName] ?? "required field";
              let reqmsg = "Please enter " + val;
              let _reqfiled = yup.date().required(reqmsg);
              validateState = {
                ...validateState,
                [item.IntName]: _reqfiled,
              };
            }
            if (item.Type == "Choice" && item.Required == "Yes") {
              let reqmsg = "Please select " + item.text.toLowerCase();
              let _reqfiled = yup.string().required(reqmsg);
              validateState = {
                ...validateState,
                [item.IntName]: _reqfiled,
              };
            }
            if (item.Type == "Number" && item.Required == "Yes") {
              let reqmsg = "Please enter " + item.text.toLowerCase();
              let _reqfiled = yup.string().required(reqmsg);
              validateState = {
                ...validateState,
                [item.IntName]: _reqfiled,
              };
            }
            if (item.Type == "Attachments" && item.Required == "Yes") {
              const val = CurrentdisplayfieldsNameTemp?.[item?.IntName] ?? "required";
              let reqmsg = "Please upload " + val + " attachment";
              let _reqfiled = yup.array().required(reqmsg);
              validateState = {
                ...validateState,
                [item.IntName]: _reqfiled,
              };
            }
          });
        })
      : "";
    return {
      validateState: validateState,
      _JsonFormFields: _JsonFormFields,
      conditionaldata: _conditiondata,
      formfieldjson: _JsonFormFields,
      conditionaljson: _ConditionalField,
      GJsonFormFields: GJsonFormFields,
      GJsonFormFieldsCond: GJsonFormFieldsCond,
      filepath: filepath,
      standardtemplatename: standardtemplatename,
      businessunitdropvalue: data.value[0]?.BusinessUnit,
      draftTypeOptions: FileNames,
      DocumentTypeField: data?.value[0]?.DocumentTypeField,
    };
  } catch (error) {
    console.log(error);
    return {};
  }
}

export const _FetchColumns = async () => {
  const token = localStorage.getItem("CurrentToken");
  const newColumn = [];
  const placeholders = [];
  try {
    const response = await axios.get(
      `${ContextService.GetUrl()}` +
        `/_api/web/lists/getbytitle('CLM365Request')/Fields?$select=*&$filter=ReadOnlyField eq false`,

      {
        headers: {
          Accept: "application/json;odata=nometadata",
          "odata-version": "",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const fields = response?.data;

    fields.value.forEach((templ: any) => {
      if (
        !["Guid_ID", "MetaInfo", "PropertyBag", "FileLeafRef", "Order", "ContentType", "Remarks"].includes(
          templ.InternalName
        )
      ) {
        let finaltem = [
          {
            key: templ.InternalName,
            Value: templ?.Title,
          },
        ];
        let nColumn = [
          {
            type: templ.TypeAsString,
            intName: templ.InternalName,
            Choices: templ.Choices,
          },
        ];
        newColumn.push(...nColumn);
        ////console.log(finaltem, "Customcolumns")
        placeholders.push(...finaltem);
        // ColumnProperties.push(finaltem);
      }
    });
    return { placeholders, newColumn };
  } catch (error) {
    console.log(error);
    return { placeholders, newColumn };
  }
};

export const getCustomColumns = async (listGUID, CurrentdisplayDocfieldsTemp) => {
  // setDocumentTypes([]);
  const token = localStorage.getItem("CurrentToken");
  let documentTypesTemp = [];
  let validateState = {};
  try {
    const response = await axios.get(
      `${ContextService.GetUrl()}` +
        `/_api/web/lists/getbytitle('CLM365Document_Type')/Items?$select=DocFormFields,SectionName&$filter=Guid_ID eq '${listGUID}'`,

      {
        headers: {
          Accept: "application/json;odata=nometadata",
          "odata-version": "",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const items = response?.data;

    if (items?.value[0]?.DocFormFields) {
      documentTypesTemp = JSON?.parse(items?.value[0]?.DocFormFields);
      JSON?.parse(items?.value[0]?.DocFormFields)?.map((item: any, ind: any) => {
        if (item.Type == "Attachments" && item.Required == "Yes") {
          let reqmsg = "Please upload " + CurrentdisplayDocfieldsTemp[item.IntName] + " attachment";
          let _reqfiled = yup.array().required(reqmsg);
          validateState = {
            ...validateState,
            [item.IntName]: _reqfiled,
          };
        }
      });
    }

    return {
      validateState: validateState,
      documenttitle: items?.value[0]?.SectionName,
      documentTypesTemp: documentTypesTemp,
      documentTypes: documentTypesTemp,
    };
  } catch (error) {
    return {};
  }
};

export const getAllApprovalInfos = async () => {
  const token = localStorage.getItem("CurrentToken");
  const allApprovalData = [];
  try {
    const response = await axios.get(
      `${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365ApprovalLevels')/items?$top=5000`,
      {
        headers: {
          Accept: "application/json;odata=nometadata",
          "odata-version": "",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const items = response?.data;

    items.value.forEach((item) => {
      ////console.log(item)
      allApprovalData.push({
        WorkflowName: item.WorkflowName,
        ApprovalType: item.ApprovalType,
        ApprovalLevel: item.ApproverLevel ? JSON.parse(item.ApproverLevel) : [],
        ApprovalLocation: item.Location,
        Contracttype: item.Contracttype ? JSON.parse(item.Contracttype) : [],
        WorkflowId: item.Id,
        ApprovalStage: item.ApprovalStage,
        BusinessUnit: item.BusinessUnit ? JSON.parse(item.BusinessUnit) : [],
        Counterparty: item?.Counterparty ? JSON.parse(item?.Counterparty||"[]") : [],
        Department: item.Department ? JSON.parse(item.Department||"[]") : [],
        DefaultFlow: item.DefaultFlow || "No"
      });
    });
    return allApprovalData;
  } catch (error) {
    const status = error?.response?.status;
      if ([401, 402, 403].includes(status)) {
      return await handleTokenExpiration(getAllApprovalInfos());
    }
    return allApprovalData;
  }
};

export const getroledata = async () => {
  const token = localStorage.getItem("CurrentToken");
  const allRoleOptions = [];
  const orgDetailsFinals = [];
  const departmentOptions = [];
  const UserGroups = [];
  try {
    const response = await axios.get(
      `${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365General')/items?$select=Role,Department,UserGroups,OrganizationInfo&$filter=Title eq '${"GeneralData"}'`,

      {
        headers: {
          Accept: "application/json;odata=nometadata",
          "odata-version": "",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const items = response?.data;
    UserGroups.push(JSON.parse(items.value[0]?.UserGroups||"{}"));
    if (items.value[0].Role != null) {
      // const roleArr = JSON.parse(items.value[0].Role);
      const orgDetails = JSON.parse(items.value[0].OrganizationInfo);
       const AllDepartmentData = JSON.parse(items.value[0].Department||"[]").filter(i => i.Status == "Active")
          const DeptOptions = AllDepartmentData.map(item => ({
            label: item.Name,
            value: item.Name,
            text: item.Name,
            key: item.GUID,
            code: item.DepartmentCode
          }))
         departmentOptions.push(DeptOptions)
      // roleArr.map((curr, index) => {
      //   allRoleOptions.push({ key: curr?.Name, text: curr?.Name });
      // });
      //  console.log(orgDetails,"orgDetails");
      let finalorg = {
        Organization_Title: orgDetails[0]?.OrganizationTitle,
        Organization_URL: orgDetails[0]?.OrganizationURL,
        Organization_Country: orgDetails[0]?.Country,
        Organization_Address_Line_1: orgDetails[0]?.Address1,
        Organization_Address_Line_2: orgDetails[0]?.Address2,
        Organization_City: orgDetails[0]?.City,
        Organization_State: orgDetails[0]?.State,
        Organization_ZipCode: orgDetails[0]?.ZipCode,
        Organization_Website: orgDetails[0]?.Website,
        Organization_Currency: orgDetails[0]?.Currency,
        Organization_Contact_Number: orgDetails[0]?.ContactNumber,
        Organization_Jurisdiction: orgDetails[0]?.OrganizationJurisdiction,
      };
      orgDetailsFinals.push(finalorg);
    }
    // setorgDetailsfinal(orgDetailsFinals);

    return {
      orgDetailsfinal: orgDetailsFinals,
      allRoleOptions: allRoleOptions,
      departmentOptions: departmentOptions[0],
      userGroups: UserGroups
    };
  } catch (error) {
    const status = error?.response?.status;
    if ([401, 402, 403].includes(status)) {
      return await handleTokenExpiration(getroledata());
    } else{
      return {
      orgDetailsfinal: orgDetailsFinals,
      allRoleOptions: allRoleOptions,
      businessUnitOptions: [],
      userGroups: UserGroups
    };
    }
  }
};

export const getcounterpartyDetails = async () => {
  const finaltemp: any[] = [];
  const token = localStorage.getItem("CurrentToken");
  try {
    const response = await axios.get(
      `${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365CounterParty')/items?$top=5000`,

      {
        headers: {
          Accept: "application/json;odata=nometadata",
          "odata-version": "",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const items = response?.data;

    items.value.forEach((item) => {
      let arr = [];
      let arr1 = [];
      arr.push(item.OrganizationName);
      arr.push(item.ID);
      let option = arr.join("|");
      finaltemp.push({
        // key: item.ID, text: item?.CounterPartyType, value: item?.OrganizationName,
        // label: item?.OrganizationName, value1:item?.Country
        key: item.ID,
        text: item?.CounterPartyType,
        value: item?.OrganizationName,
        label: item?.OrganizationName,
        value1: item?.Country,
        email: item?.Email,
        State: item?.State,
        City: item?.City,
        ZipCode: item?.ZipCode,
        Address1: item?.Address1,
        Address2: item?.Address2,
        Contactnumber: item?.ContactNumber,
        OrganizationJurisdiction: item?.OrganizationJurisdiction,
        Guid_ID: item?.Guid_ID,
      });
    });
    // setoptionsCounterparty(finaltemp);
    return finaltemp;
  } catch (error) {
    return finaltemp;
  }
};


export const getDatafromreqlist =(data,setData,optionConName,BusinessunitOptions,GJsonFormFields,GJsonFormFieldsCond,getnumbervalue,getChoice)=>{

    // if (data.Status == "Rejected") {
    //   setButtonSaveText1(strings.Submit);
    // }
    const allActivityLogs=[]
   allActivityLogs.push(...JSON.parse(data.Activity_Log));
    let attachfilename=[]
    if (data.AttachmentFiles) {
        attachfilename = data.AttachmentFiles.map((x) => x.FileName);
      }

   const deletefilename = data.File_Name;

    let contractid = data.Contract_Type.split("|");
    let contractCode='';
    let contractName=''
    optionConName.map((e) => {
      if (e.guid == data.Contract_Type.split("|")[1]) {
       
        contractCode=e.code;
        contractName=e.text;
      }
    });

    let _contractkey = parseInt(contractid[0]);
    let _arrBu='';
    let businessCode='';
    let businessUnitName='';
    let selectedChoiceKey='Definite'

    let dataText={};
    let dataNote={};
    let dataNumber={};
    let dataChoice2={};
    let dateDatepicker={};
    let counterpartyname='';
    let attachmentFileDataTemp={}
    // contracteditId = _contractkey;
    if (
      data.Business_Unit != undefined &&
      data.Business_Unit != null &&
      data.Business_Unit != ""
    ) {
       _arrBu = data.Business_Unit;
      //console.log(_arrBu, "_arrBu")
      BusinessunitOptions.map((e) => {
        if (e.key == data.Business_Unit) {
            businessCode=e.code;
            businessUnitName=e.text;
        }
      });
    }

    GJsonFormFields
      ? Object.entries(GJsonFormFields)?.map(
          ([key1, column]: any, index: any) => {
   
            column.items
              ? column.items.map((itemvalue) => {
                  if (itemvalue.Type == "Text") {
             
                    dataText={
                        ...dataText,
                        [itemvalue.IntName]:data[itemvalue.IntName]
                    }
                  }
                  if (itemvalue.IntName == "Contract_Term") {
                
                    selectedChoiceKey= data[itemvalue.IntName] as string
                  }
                  if (itemvalue.Type == "Plus") {
                    if (data[itemvalue.IntName]) {
        
                      counterpartyname=JSON.parse(data[itemvalue.IntName])
                    }
                  }
                  if (itemvalue.Type == "DateTime") {

                    dateDatepicker={
                        ...dateDatepicker,
                        [itemvalue.IntName] : data[
                            itemvalue.IntName
                          ]
                            ? new Date(data[itemvalue.IntName])
                            : null
                    }
                  }
                  if (itemvalue.Type == "Note") {

                    dataNote={
                        ...dataNote,
                        [itemvalue.IntName] :data[itemvalue.IntName]
                    }
                  }
                  if (itemvalue.Type == "Number") {
                    dataNumber={
                        ...dataNumber,
                        [itemvalue.IntName]:data[itemvalue.IntName]
                    }
                    getnumbervalue({
                      target: {
                        value: data[itemvalue.IntName],
                        id: itemvalue.IntName,
                      },
                    });
                  }
                  if (itemvalue.Type == "Choice") {
                
                    dataChoice2={
                        ...dataChoice2,
                        [itemvalue.IntName]:
                      data[itemvalue.IntName]
                    }
                    getChoice(
                      {
                        key: data[itemvalue.IntName],
                        text: data[itemvalue.IntName],
                      },
                      itemvalue.IntName
                    );
                  }
                  if (itemvalue.Type == "Attachments") {
       
                    attachmentFileDataTemp={
                        ...attachmentFileDataTemp,
                        [itemvalue.IntName] :
                      data[itemvalue.IntName]
                    }
                  }
                })
              : null;
          }
        )
      : null;
    Object.entries(GJsonFormFieldsCond)?.map(
      ([key1, column]: any, index: any) => {

        if (column.FieldType == "Number") {
          column.Choices?.map((itemvalue) => {
            itemvalue.field?.map((choicefields) => {
              if (choicefields.type == "Text") {
                dataText={
                    ...dataText,
                    [choicefields.InternalName]:data[choicefields.InternalName]
                }
              }
              if (choicefields.type == "Note") {
                dataNote={
                    ...dataNote,
                    [choicefields.InternalName]:data[choicefields.InternalName]
                }
              }
              if (choicefields.type == "Number") {
        
                dataNumber={
                    ...dataNumber,
                    [choicefields.InternalName] :
                    data[choicefields.InternalName]
                }
              }
              if (choicefields.type == "Choice") {
            
                dataChoice2={
                    ...dataChoice2,
                    [choicefields.InternalName]:
                  data[choicefields.InternalName]
                }
              }
              if (choicefields.type == "DateTime") {
      
                dateDatepicker={
                    ...dateDatepicker,
                    [choicefields.InternalName] : data[
                        choicefields.InternalName
                      ]
                        ? new Date(data[choicefields.InternalName])
                        : null
                }
              }
            });
          });
        }
        if (column.FieldType == "Choice") {
          column.Choices?.map((itemvalue) => {
            if (itemvalue.type == "Text") {
    
            dataText={
                ...dataText,
                [itemvalue.InternalName]:data[itemvalue.InternalName]
            }
            }
            if (itemvalue.InternalName == "Contract_Term") {
            selectedChoiceKey= data[itemvalue.InternalName] as string
            }
            if (itemvalue.type == "Plus") {
              if (data[itemvalue.InternalName]) {
                dataText={
                    ...dataText,
                    [itemvalue.InternalName]:data[itemvalue.InternalName]
                }
              }
            }
            if (itemvalue.type == "DateTime") {
 
            dateDatepicker={
                ...dateDatepicker,
                [itemvalue.InternalName] : data[
                    itemvalue.InternalName
                  ]
                    ? new Date(data[itemvalue.InternalName])
                    : null
            }
            }
            if (itemvalue.type == "Note") {
 
            dataNote={
                ...dataNote,
                [itemvalue.InternalName]:data[itemvalue.InternalName]
            }
            }
            if (itemvalue.type == "Number") {
              dataNumber={
                ...dataNumber,
                [itemvalue.InternalName] :
                data[itemvalue.InternalName]
            }
            }
            if (itemvalue.type == "Choice") {
            dataChoice2={
                ...dataChoice2,
                [itemvalue.InternalName] :data[itemvalue.InternalName]
            }
            }
          });
        }
      }
    );

    let _conditiondata = [];
    GJsonFormFieldsCond
      ? Object.entries(GJsonFormFieldsCond)?.map(
          ([key1, column]: any, index: any) => {

            let _choiceoptions = [];
            column.Choices.length > 0
              ? column.Choices.map((items) => {
                  _choiceoptions.push({
                    key: items.value,
                    text: items.value,
                  });
                })
              : "";
            let finalvalueuniq = Object.values(
              _choiceoptions.reduce(
                (acc, cur) => Object.assign(acc, { [cur.key]: cur }),
                {}
              )
            );
            _conditiondata.push({
              internalname: key1,
              value: finalvalueuniq,
            });
          }
        )
      : "";

    setData((c)=>({
        ...c,
        requestGuid:data.Guid_ID,
        RequestGuid:data.Guid_ID,
        status:data.Status,
        termObj:JSON.parse(data?.Term),
        remark:data.Remarks,
        requestNumber:data.Request_Number,
        requestApprovalstatus:data.RequestApproval,
        DraftApprovalStatus:data?.DraftApproval || "Not Started",
        attachfilename:attachfilename,
        deletefilename:deletefilename,
        drafttypelist:data.Draft_Type,
        requesttypevalue:data.Request_Type,
        allActivityLogs:allActivityLogs,
        contracttypeId:data.Contract_Type,
        contractCode:contractCode,
        contractName:contractName,
        businessunitdropvalue:_arrBu,
        businessCode:businessCode,
        businessUnitName:businessUnitName,
        Statusvalue:data.Status,
        contracttypeselect:_contractkey,
        formfieldjson:GJsonFormFields,
        conditionaljson:GJsonFormFieldsCond,
        selectedChoiceKey:selectedChoiceKey,
        dataText:dataText,
        dataNote:dataNote,
        dataNumber:dataNumber,
        dataChoice2:dataChoice2,
        dateDatepicker:dateDatepicker,
        attachmentFileDataTemp:attachmentFileDataTemp,
        _conditiondata:_conditiondata,
        counterpartyname:counterpartyname
    }))


//   });
}


export  async function getDocumentAttachments(listGUID,documentTypesTemp,setData) {
    const token = localStorage.getItem("CurrentToken");

   let documentTypesKeyPairs = {};
    let documentTypeID = "";
    try {
        const response = await axios.get(
            `${ContextService.GetUrl()}` +
              `/_api/web/lists/getbytitle('CLM365DocumentAttachment')/Items?$select=*&$filter=RequestContract_GuidID eq '${listGUID}'`,
           
            {
              headers: {
                Accept: "application/json;odata=nometadata",
                "odata-version": "",
                Authorization: `Bearer ${token}`,
              },
            }
          )
    
            const items=response?.data
            const keyValuePairs = {};
            if (items?.value[0]) {
              documentTypeID = items?.value[0]?.ID;
          
              let tempData = items.value[0];
              for (const key in tempData) {
                documentTypesTemp.forEach((doc) => {
                  if (doc.IntName === key) {
                    keyValuePairs[doc.IntName] = tempData[key];
                    documentTypesKeyPairs[doc.IntName] = tempData[key];
                  }
                });
              }
            //   setDocumentTypeTemp(keyValuePairs);
            }
            setData((c)=>({
                ...c,
                documentTypeID:documentTypeID,
                documentTypeTemp:keyValuePairs,
                documentTypesKeyPairs:documentTypesKeyPairs
            }))
   
    } catch (error) {
        
    }

  
  }


  const url = `/_api/web/lists/getbytitle('CLM365Request')/items?$top=5000&$select=Title,Guid_ID,File_Name,Draft_Type,ActualFileName&$orderby=Created desc`;


export async function getFileInfo(FileName) {
    const token=localStorage.getItem("CurrentToken");
  const url = `/_api/web/lists/getfolderbyserverrelativeurl('CLM365RequestDraft')/files/getbyname('${FileName}')/ListItemAllFields`;
  
  try {
    const response = await axios.get(`${ContextService.GetUrl()}${url}`, {
      headers: {
        Accept: "application/json;odata=nometadata", 
        "odata-version": "",                      
        Authorization: `Bearer ${token}`, 
      }
    });
    
    // console.log(response.data);
    return response.data;  
    
  } catch (error) {
    console.error('Error fetching file data:', error);
  }
}


export  async function getRequestNumberSequence(setData,data) {
   let RequestSequenceValue = [];
   let requestnumbertemp;
   let generalListId='';
   let requestsequencenum;
    const token = localStorage.getItem("CurrentToken");
try {
    const response = await axios.get(
        `${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365General')/items?$select=ID,RequestSequence,LastRequestSequence&$filter=Title eq '${"GeneralData"}'`,
        {
          headers: {
            Accept: "application/json;odata=nometadata",
            "odata-version": "",
            Authorization: `Bearer ${token}`,
          },
        }
      )
const items=response?.data;
        if (items.value.length > 0) {
         
          generalListId = items.value[0].ID;
          const requestSequenceArray = JSON.parse(
            items.value[0]?.RequestSequence
          );
          RequestSequenceValue = [];
          requestnumbertemp = [];
          requestSequenceArray.forEach(item => {
            if (!("Department" in item)) item.Department = "All|All";
            if (!("DepartmentType" in item)) item.DepartmentType = "Department Code";
            if (!("DepartmentField" in item)) item.DepartmentField = "-";
          });
          requestSequenceArray?.map((curr, index) => {
            //console.log(filtercontractName, "filtercontractName");
            if (
              curr?.BusinessUnitType.split("|")[0] == data()?.businessunitdropvalue &&
              curr?.ContractType?.split("|")[0] == data()?.contracttypeId?.split("|")[1] &&
              (curr.Department.split("|")[0] == data()?.DepartmentDetails().SelectedDepartment["key"] || curr.Department.split("|")[0] == "All")
            ) {
              let finaltemp = {
                // ID: items.value[0]?.ID,
                BusinessUnitType: curr?.ContractType?.split("|")[1],
                ContractTypeVal: curr?.ContractType?.split("|")[1],
                ContractType: curr?.ContractType,
                RequestNumber:
                  curr?.DepartmentType == "Department Free Text" ? curr?.DepartmentType : curr?.DepartmentFreetext + curr?.DepartmentField + 
                  curr?.Businessunit +
                  curr?.Field1 +
                  curr?.Contract +
                  curr?.Field2 +
                  curr?.Year +
                  curr?.Field3 +
                  curr?.Sequential,
                editindex: index,
                Businessunit:
                  curr?.Businessunit == "N/A" ? "" : curr?.Businessunit,
                Contract: curr?.Contract == "N/A" ? "" : curr?.Contract,
                Year: curr?.Year == "N/A" ? "" : curr?.Year,
                Sequential: curr?.Sequential == "" ? "" : curr?.Sequential,
                Field1: curr?.Field1,
                Field2: curr?.Field2,
                Field3: curr?.Field3,
                Department: curr?.Department.split("|")[1],
                DepartmentType: curr?.DepartmentType == "N/A" ? "" : curr.DepartmentType,
                DepartmentFreeText: curr?.DepartmentFreetext || "",
                DepartmentField: curr?.DepartmentField
              };
            //   setRequestSequence(curr?.CurrentSequence);
              requestsequencenum = curr?.CurrentSequence;
              requestnumbertemp = finaltemp;
              //console.log("finaltemp111", requestnumbertemp);
            }
            let finaldatasync = {
              GUID: curr?.GUID,
              BusinessUnitType: curr?.BusinessUnitType,
              ContractType: curr?.ContractType,
              Businessunit:
                curr?.Businessunit == "N/A" ? "" : curr?.Businessunit,
              Contract: curr?.Contract == "N/A" ? "" : curr?.Contract,
              Year: curr?.Year == "N/A" ? "" : curr?.Year,
              Sequential: curr?.Sequential == "" ? "" : curr?.Sequential,
              Field1: curr?.Field1,
              Field2: curr?.Field2,
              Field3: curr?.Field3,
              RequestSequence: curr?.RequestSequence,
              CurrentSequence: curr?.CurrentSequence,
              Department: curr?.Department,
              DepartmentType: curr?.DepartmentType == "N/A" ? "" : curr?.DepartmentType,
              DepartmentFreeText: curr?.DepartmentFreetext || "",
              DepartmentField: curr?.DepartmentField
            };
            RequestSequenceValue.push(finaldatasync);
          });
          if (
            requestnumbertemp == null ||
            requestnumbertemp == undefined ||
            requestnumbertemp == ""
          ) {
            RequestSequenceValue = [];
            requestnumbertemp = [];
            requestSequenceArray.forEach(item => {
              if (!("Department" in item)) item.Department = "All|All";
              if (!("DepartmentType" in item)) item.DepartmentType = "Department Code";
              if (!("DepartmentField" in item)) item.DepartmentField = "-";
            });
            requestSequenceArray?.map((curr, index) => {
              if (
                curr?.BusinessUnitType?.split("|")[1] == "All" &&
                curr?.ContractType?.split("|")[1] == "All" && curr.Department.split("|")[0] == "All"
              ) {
                let finaltemp = {
                  // ID: items.value[0]?.ID,
                  BusinessUnitType: curr?.ContractType?.split("|")[1],
                  ContractTypeVal: curr?.ContractType?.split("|")[1],
                  ContractType: curr?.ContractType,
                  RequestNumber:
                    curr?.Businessunit +
                    curr?.Field1 +
                    curr?.Contract +
                    curr?.Field2 +
                    curr?.Year +
                    curr?.Field3 +
                    curr?.Sequential,
                  editindex: index,
                  Businessunit:
                    curr?.Businessunit == "N/A" ? "" : curr?.Businessunit,
                  Contract: curr?.Contract == "N/A" ? "" : curr?.Contract,
                  Year: curr?.Year == "N/A" ? "" : curr?.Year,
                  Sequential: curr?.Sequential == "" ? "" : curr?.Sequential,
                  Field1: curr?.Field1,
                  Field2: curr?.Field2,
                  Field3: curr?.Field3,
                  Department: curr.Department,
                  DepartmentType: curr.DepartmentType == "N/A" ? "" : curr.DepartmentType,
                  DepartmentFreeText: curr.DepartmentFreetext || "",
                  DepartmentField: curr.DepartmentField
                };
                // setRequestSequence(curr?.CurrentSequence);
                requestsequencenum = curr?.CurrentSequence;
                requestnumbertemp = finaltemp;
                //console.log("finaltemp111", requestnumbertemp);
              }
              let finaldatasync = {
                GUID: curr?.GUID,
                BusinessUnitType: curr?.BusinessUnitType,
                ContractType: curr?.ContractType,
                Businessunit:
                  curr?.Businessunit == "N/A" ? "" : curr?.Businessunit,
                Contract: curr?.Contract == "N/A" ? "" : curr?.Contract,
                Year: curr?.Year == "N/A" ? "" : curr?.Year,
                Sequential: curr?.Sequential == "" ? "" : curr?.Sequential,
                Field1: curr?.Field1,
                Field2: curr?.Field2,
                Field3: curr?.Field3,
                RequestSequence: curr?.RequestSequence,
                CurrentSequence: curr?.CurrentSequence,
                Department: curr.Department,
                DepartmentType: curr.DepartmentType == "N/A" ? "" : curr.DepartmentType,
                DepartmentFreeText: curr.DepartmentFreetext || "",
                DepartmentField: curr.DepartmentField
              };
              RequestSequenceValue.push(finaldatasync);
            });
          
          }
        }

        setData((c)=>({
            ...c,
            RequestSequenceValue:RequestSequenceValue,
            requestnumbertemp:requestnumbertemp,
            generalListId:generalListId,
            requestsequencenum:requestsequencenum, 
        }))


} catch (error) {
    setData((c)=>({
        ...c,
        RequestSequenceValue:RequestSequenceValue,
        requestnumbertemp:requestnumbertemp,
        generalListId:generalListId,
        requestsequencenum:requestsequencenum, 
    }))

}
  }


  export async function getGroupIdByName(groupName) {
    const token = localStorage.getItem("CurrentToken");
    try {
        const currentWebUrl = ContextService.GetUrl();
        const requestUrl = `${currentWebUrl}/_api/web/sitegroups?$filter=Title eq '${encodeURIComponent(groupName)}'&$top=1`;
  
        const response = await fetch(requestUrl, {
            method: 'GET',
            headers: {
                'Accept': 'application/json;odata=verbose',
                Authorization: `Bearer ${token}`,
            }
        });
  
        if (!response.ok) {
            throw new Error(`Failed to get group ID. Status: ${response.status}`);
        }
  
        const data = await response.json();
        return data.d.results.length > 0 ? data.d.results[0].Id : null;
    } catch (error) {
        console.error('Error fetching group ID:', error);
        return null;
    }
  }


  export async function deleteFileFromFolder(
    folderName: string,
    fileName: string
  ): Promise<void> {
    try {
    //   const web = new Web(ContextService.GetUrl());
    //   const library = web.lists.getByTitle("CLM365TaskAttachment");

    //   const rootFolder = await library.rootFolder.get();
    //   const folderUrl = `${rootFolder.ServerRelativeUrl}/${folderName}`;

    //   const fileUrl = `${folderUrl}/${fileName}`;
    //   const file = web.getFileByServerRelativeUrl(fileUrl);

    //   await file.delete();

    const token=localStorage.getItem("CurrentToken");

    const libraryUrl = `/_api/web/lists/getbytitle('CLM365TaskAttachment')/rootfolder`;
    const libraryResponse = await axios.get(`${ContextService.GetUrl()}${libraryUrl}`, {
      headers: {
        Accept: "application/json;odata=nometadata",
        "odata-version": "",
        Authorization: `Bearer ${token}`,
      },
    });

    const rootFolderUrl = libraryResponse.data.ServerRelativeUrl;
    const folderUrl = `${rootFolderUrl}/${folderName}`;

    // Now get the file URL and delete the file
    const fileUrl = `${folderUrl}/${fileName}`;
    const fileDeleteUrl = `/_api/web/getfilebyserverrelativeurl('${fileUrl}')`;

    const deleteResponse = await axios.post(
      `${ContextService.GetUrl()}${fileDeleteUrl}/recycle`,
      {}, 
      {
        headers: {
          Accept: "application/json;odata=nometadata",
          "odata-version": "",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    
    
    console.log(`File '${fileName}' deleted successfully.`);


    } catch (error) {
      console.error("Error deleting file:", error);

    }
  }



  export   async function Updateformfieldvalues(
    AllfieldValues,
    binary,
    fileName,
    finalTemplatelib,
    data
  ) {
    if (
      fileName.split(".")[fileName.split(".").length - 1].toLowerCase() == "pdf"
    ) {
      updatecontractformdata(fileName, finalTemplatelib, binary,data()?.fileIdupdate);
    } else {

      const zip = new JSZip();
      await zip
        .loadAsync(binary)
        .then(async (zip: any) => {
          //console.log("standdardtemp file loadAsync() then:Test 6");
          return zip
            .file("word/document.xml")
            .async("string")
            .then(async (documentXml) => {
 
              const pattern =
                /<w:fldChar w:fldCharType="begin"\>.*?<w:fldChar w:fldCharType="end" \/>/g;
              let arr: any = documentXml.match(pattern);
              // console.log(arr, "arr");
              arr?.map((element: any) => {
       
                const nameMatch = element.match(/name="(.*?)"/);
                // console.log(nameMatch,"nameMatch")
                if (nameMatch) {

                  let _internalField = nameMatch[1]
                    .split("_")
                    .slice(0, -1)
                    .join("_");
                  const filteredData = Object.keys(AllfieldValues)
                    .filter((key) => key === _internalField)
                    .reduce((obj, key) => {
                      obj[key] = AllfieldValues[key];
                      return obj;
                    }, {});
                  // console.log(filteredData, "filteredData");
                  // if (fields.includes(nameMatch[1])) {
                  if (Object.entries(filteredData).length) {
                    // console.log(filteredData[_internalField], "nameMatch[1]");
                    let textInputValue = element.match(
                      /<w:textInput><w:type w:val="text" \/><w:default w:val="(.*?)" \/><w:format w:val="None" \/><\/w:textInput>/g
                    )[0];
                   
                    const regex =
                      /<w:textInput><w:type w:val="text" \/><w:default w:val="(.*?)" \/><w:format w:val="None" \/><\/w:textInput>/;
                    const match1 = textInputValue.match(regex);
                    // console.log(match1,"match1");
                    // console.log(match1[1], "${match1[1]}");
                    let _fieldvalue = "";
                    let _fieldvalueTest =
                      /^(Sun|Mon|Tue|Wed|Thu|Fri|Sat)\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{2}\s\d{4}\s\d{2}:\d{2}:\d{2}\sGMT[+-]\d{4}\s\([\w\s]+\)$/.test(
                        filteredData[_internalField]
                      );
                    if (_internalField == "Counterparty_Name") {
                      // let _value = (filteredData[_internalField]).split('|');
                      // _fieldvalue = _value[0];
                      let counterParty = JSON.parse(
                        filteredData[_internalField]
                      );
                      let arr = [];
                      counterParty?.map((items) => {
                        arr.push(items.OrgName);
                      });
                      _fieldvalue = arr?.join(", ");
                      // _fieldvalue = arr[0];
                    } else if (_internalField == "Contract_Type") {
                      // let _value = (filteredData[_internalField]).split('|');
                      // _fieldvalue = _value[0];
                      let Contracttype =
                        filteredData[_internalField].split("|");
                      //console.log(Contracttype, "Contracttype");
                      _fieldvalue =data()?.currentContractName[Contracttype[1]];
                      //console.log(_fieldvalue, "_fieldvalue");
                    } else if (_internalField == "Business_Unit") {
                      // let _value = (filteredData[_internalField]).split('|');
                      // _fieldvalue = _value[0];
                      let BusinessUnitFinal = filteredData[_internalField];
                      _fieldvalue = data()?.currentbusUnitName[BusinessUnitFinal];
                      //console.log(_fieldvalue, "_fieldvalue");
                    } else {
                      _fieldvalue = _fieldvalueTest
                        ? moment(new Date(filteredData[_internalField])).format(
                            "MM/DD/YYYY"
                          )
                        : filteredData[_internalField];
                      // _fieldvalueTest=false;
                    }
      
                    documentXml = documentXml.replaceAll(
                      '<w:default w:val="' + match1[1],
                      '<w:default w:val="' + _fieldvalue
                    );
                    documentXml = documentXml.replaceAll(
                      ">" + match1[1],
                      ">" + _fieldvalue
                    );
                 
                  }
                }
              });
              // console.log(documentXml, "return documentXml then:Test 7");
              return documentXml;
            });
        })
        .then((documentXml: any) => {
          var updatedContentBlob = new Blob([documentXml], {
            type: "text/xml",
          });
          zip.file("word/document.xml", updatedContentBlob);
          zip.generateAsync({ type: "blob" }).then(function (blob: any) {
            downloadDocx(blob, "updated_document.docx");
          });
        });
    }
    const downloadDocx = (blob: any, filename1: any) => {
      const file = new File([blob], fileName, {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });

      updatecontractformdata(fileName, finalTemplatelib, file,data()?.fileIdupdate)
    };
  }


//   export async function updatecontractformdata(filename, finalTemplatelib, file1,fileIdupdate) {
//     const token = localStorage.getItem("CurrentToken");
//     // var url = this.context.pageContext.web.serverRelativeUrl;
//     let file = file1; //attachFile2[0]//imageFile[0];
//     //console.log(file, "file")
//     let fileUNameExt = filename.split(".")[filename.split(".").length - 1];



// try {
//     // Get the 'CLM365RequestDraft' list details (folder URL)
//     const listUrl = `/_api/web/lists/getbytitle('CLM365RequestDraft')?$select=Title,RootFolder/ServerRelativeUrl&$expand=RootFolder`;
//     const listResponse = await axios.get(`${ContextService.GetUrl()}${listUrl}`, {
//       headers: {
//         Accept: "application/json;odata=nometadata",
//         "odata-version": "",
//         Authorization: `Bearer ${token}`,
//       },
//     });
    

//     // Get the server relative URL of the folder
//     const folderUrl = listResponse.data.d.RootFolder.ServerRelativeUrl;
    
//     // Prepare the file URL
//     const fileNameWithExt = `${fileIdupdate.replace(/#/g, "%23")}.${fileUNameExt}`;

//     // Upload the file to the folder
//     const fileUploadUrl = `/_api/web/getfolderbyserverrelativeurl('${folderUrl}')/files/add(url='${fileNameWithExt}', overwrite=true)`;

//     const fileUploadResponse = await axios.post(`${ContextService.GetUrl()}${fileUploadUrl}`, file, {
//       headers: {
//         Accept: "application/json;odata=nometadata",
//         "odata-version": "",
//         Authorization: `Bearer ${token}`,
//         "Content-Type": "application/json",
//       },
//     });

//     // After file is uploaded, update the file item if needed
//     const fileItemUrl = fileUploadResponse.data.d.ListItemAllFields.__metadata.uri;
//     const updateUrl = `${fileItemUrl}/update`;

//     await axios.post(`${ContextService.GetUrl()}${updateUrl}`, finalTemplatelib, {
//       headers: {
//         Accept: "application/json;odata=nometadata",
//         "odata-version": "",
//         Authorization: `Bearer ${token}`,
//         "Content-Type": "application/json",
//       },
//     });

//     console.log("File uploaded and item updated successfully.");
    
//   } catch (error) {
//                 alert(
//               "Look like you don't have permission to save information in this SharePoint site collection, please contact either site admin or application admin to provide site member / contribute permissions."
//             );
//     console.error("Error updating contract form data:", error);

//   }
//   }
export async function updatecontractformdata(filename, finalTemplatelib, file1, fileIdupdate) {
  try {
    // Retrieve the current token from localStorage
    const token = localStorage.getItem("CurrentToken");

    // Determine the file name and extension
    let file = file1;
    let fileUNameExt = filename.split(".")[filename.split(".").length - 1];
    const fileNameWithExt = `${fileIdupdate.replace(/#/g, "%23")}.${fileUNameExt}`;

    // Get the root folder URL of the 'CLM365RequestDraft' list
    const rootFolderUrl = `${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365RequestDraft')/rootfolder`;
    const response = await axios.get(rootFolderUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    const rootFolder = response.data;
    if (rootFolder.ServerRelativeUrl) {
      const folderUrl = rootFolder.ServerRelativeUrl;
      
      // Construct the upload file URL
      const uploadFileUrl = `${ContextService.GetUrl()}/_api/web/getfolderbyserverrelativeurl('${folderUrl}')/files/add(overwrite=true, url='${fileNameWithExt}')`;
      
      // Upload the file to the folder
      const uploadFileResponse = await axios.post(uploadFileUrl, file, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/octet-stream",
        },
      });
      // console.log(`File ${fileNameWithExt} uploaded successfully:`, uploadFileResponse.data);

      if (uploadFileResponse.data) {
        // After successful upload, update the file item
        const fileItemUrl = uploadFileResponse.data.d.ListItemAllFields.__metadata.uri;
        const updateUrl = `${fileItemUrl}/update`;

        await axios.post(`${ContextService.GetUrl()}${updateUrl}`, finalTemplatelib, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });

        console.log("File uploaded and item updated successfully.");
      }
    }
  } catch (error) {
    alert(
      "It looks like you don't have permission to save information in this SharePoint site collection. Please contact the site admin or application admin for site member/contribute permissions."
    );
    console.error("Error updating contract form data:", error);
  }
}



  export   async function createTasksinbatch(
    data,
    dataplaceholder,
    requestId,
    itemid,
    reqNumber,
    placeholders,
    Users,
    allActivityLogs,
    allMails,
    requestData,
    Contract_Request_Title,
  ) {
    let draftData=[]
    // allActivityLogs = [];
    // let sendtoEmail = [ContextService.GetCurrentUser().email];
    let web = new Web(ContextService.GetUrl());
    let _list = web.lists.getByTitle("CLM365ContractTasks");
    const entityTypeFullName = await _list.getListItemEntityTypeFullName();
    //for (var y = 0; y < empcol.length; y++) {
    const batch = web.createBatch();
    let batchlength = 0;

    for (var i = 0; i < data.length; i++) {
      dataplaceholder = [];
      dataplaceholder.push(...placeholders);
      //for inactive users
      for (let k = 0; k < data[i]?.AssignedToId.length; k++) {
        let assignedUser = Users.filter(
          (j) => j.Id == data[i]?.AssignedToId[k]
        );
        if (assignedUser[0].UserStatus == "Inactive") {
          const userindex = data[i]?.AssignedToId.indexOf(
            data[i]?.AssignedToId[k]
          );
          if (userindex !== -1) {
            data[i].ApproverName[userindex] = Users.filter(
              (i) => i.Id == assignedUser[0].AssignTo
            )[0]?.text;
            data[i].AssignedToId[userindex] = assignedUser[0].AssignTo;
          }
        }
      }
      const modifiedURL = `${
        window.location.href.split("#")[0].split(".aspx")[0]
      }.aspx?TaskID=${data[i]?.TaskGudId}&PanelName=${"Comments"}#/`;
      const existingKeyIndex = dataplaceholder.findIndex(
        (item) => item.key === "Request_URL"
      );
      if (existingKeyIndex !== -1) {
        dataplaceholder[
          existingKeyIndex
        ].Value = `<a href="${modifiedURL}" onclick="window.open(this.href, 'Snopzer',
        'left=20,top=20,width=500,height=500,toolbar=1,resizable=0'); return false;" >Click here</a>`;
      } else {
        dataplaceholder.push({
          key: "Request_URL",
          Value: `<a href="${modifiedURL}" onclick="window.open(this.href, 'Snopzer',
          'left=20,top=20,width=500,height=500,toolbar=1,resizable=0'); return false;" >Click here</a>`,
        });
      }
      const placeholders1 = [
        { key: "Assigned_To", Value: data[i]?.ApproverName },
      ];
      dataplaceholder.push(...placeholders1);
      if (data[i].Status == "Completed") {
        const placeholders2 = [
          {
            key: "Originator",
            Value: data[i]?.ApproverName,
          },
        ];
        dataplaceholder.push(...placeholders2);
        var activityTemp = ActivityService.getActivity(
          data[i]?.TaskName,
          dataplaceholder,
          " ",
          "",
          allMails, // sendtoEmail,
          "No"
        );
        allActivityLogs.push(activityTemp);

        let activitylogKey;
        switch (data[i]?.TaskName) {
          case "Business Approval":
            activitylogKey = "Business Approved";
            break;
          case "Additional Task":
            activitylogKey = "Additional Task Approved";
            break;
          case "Legal Review":
            activitylogKey = "Legal Review Approved";
            break;
          // case "Draft Approval":
          //   activitylogKey = "Draft Approved"
          //   break;
          // case "Execution Approval":
          //   activitylogKey = "Execution Approved"
          //   break;
          default:
            activitylogKey = "Request Approved";
            break;
        }
        var activityTemp1 = ActivityService.getActivity(
          activitylogKey,
          dataplaceholder,
          requestData()?.remark || " ",
          "",
          allMails, //sendtoEmail,
          "No"
        );
        allActivityLogs.push(activityTemp1);
      } else {
        allMails["To"] = data[i].AssignedToEmail;
        if (data[i].Mandatory == true) {
          var activityTemp = ActivityService.getActivity(
            data[i]?.TaskName,
            dataplaceholder,
            requestData()?.remark || " ",
            requestData()?.allAttachementFiles,
            allMails, //data[i].AssignedToEmail,
            "yes"
          );
          allActivityLogs.push(activityTemp);
        }
      }
      let stage = "";
      if (requestData()?.businessData.length != 0) {
        stage = "Business Approval";
      } else if (draftData.length != 0) {
        stage = "Draft Approval";
      }
      batchlength = batchlength + 1;
      if (data[i].Mandatory == true) {
        _list.items
          .inBatch(batch)
          .add(
            {
              Title: data[i].TaskTitle,
              ContractType: data[i].ContractType,
              RequestType: data[i].RequestType,
              Task_Type: data[i].TaskName,
              TaskStage: stage,
              BusinessUnit: data[i].BusinessUnit,
              Status: data[i].Status,
              DueDate: data[i].DueDate,
              AssignedToId: {
                results:
                  data[i].AssignedToId?.length > 0
                    ? data[i].AssignedToId?.flat(2)
                    : [],
              },
              RequestGuid: requestId,
              Contract_Request_Title: Contract_Request_Title,
              TaskGuid: data[i].TaskGudId ? data[i].TaskGudId : "",
              Optional: data[i].Optional,
              Other_Actions: JSON.stringify({
                OnRejection: data[i].OnRejection,
                DueDays: data[i].DueDays,
                EditCheck: data[i].EditCheck,
                HoldCheck: data[i].HoldCheck,
                DraftUpload: data[i].DraftUpload,
              }),
              LevelStage : data[i].TaskName
            },
            entityTypeFullName
          )
          .then((b) => {
            //console.log(b);
          })
          .catch((e) => {
            // //console.log("column check");
          });
      }
    }
    if (data.length == batchlength) {
      await batch.execute().then(() => {
        let finaltaskTemplate = {
          Activity_Log: JSON.stringify(allActivityLogs),
          Request_Number: reqNumber,
        };
        const token = localStorage.getItem("CurrentToken");
        // updateActivity(finaltaskTemplate, itemid);
        const updateurl =
        ContextService.GetUrl() +
        "/_api/web/lists/getbytitle('CLM365Request')/items('" +
        requestId +
        "')";
        axios
        .post(updateurl, {
          headers: {
            Accept: "application/json;odata=nometadata",
            "Content-type": "application/json;odata=nometadata",
            "odata-version": "",
            "IF-MATCH": "*",
            "X-HTTP-Method": "MERGE",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(finaltaskTemplate),
        })

      });
    }
  }


  export   function updateCurrentSequence(data,setData) {
    let finalTemplate;
    // let requestsequencenum=data()?.requestsequencenum;
    let requestnumbertemp=data()?.requestnumbertemp
    let requestsequencenum=data()?.requestsequencenum
    const token=localStorage.getItem("CurrentToken");
    if (
      requestnumbertemp.editindex != undefined &&
      requestnumbertemp.editindex != null
    ) {
      let incrementedValue = parseInt(requestsequencenum) + 1;
      let resultAsString = incrementedValue.toString();
      const tempArr = [...data()?.RequestSequenceValue];
      const currentData = {
        ...tempArr[requestnumbertemp.editindex],
        // BusinessUnitType: businessunitdropvalue,
        CurrentSequence: resultAsString,
      };
      tempArr[requestnumbertemp.editindex] = currentData;
      requestsequencenum = (parseInt(requestsequencenum) + 1).toString();
      finalTemplate = {
        RequestSequence: JSON.stringify(tempArr),
        LastRequestSequence: requestsequencenum,
      };
    } else {
      requestsequencenum = (parseInt(requestsequencenum) + 1).toString();
      finalTemplate = {
        LastRequestSequence: requestsequencenum,
      };
    }
    setData((c)=>({
      ...c,
      requestsequencenum:requestsequencenum
    }))

    const _url =
      ContextService.GetUrl() +
      "/_api/web/lists/getbytitle('CLM365General')/items('" +
      data()?.generalListId +
      "')";
       axios.post(_url, finalTemplate,{
        headers: {
          Accept: "application/json;odata=nometadata",
          "Content-type": "application/json;odata=nometadata",
          "odata-version": "",
          "IF-MATCH": "*",
          "X-HTTP-Method": "MERGE",
          Authorization: `Bearer ${token}`, 
        },
        // body: JSON.stringify(finalTemplate),
      })
      .then((response) => {
        if (response.status === 204) {
          console.log("Successfully updated.");
        } else {
          console.warn("Unexpected response status:", response.status);
        }
      })
      .catch((error) => {
        console.error("Error updating the item:", error);
      });
    
  }


  


// export async function uploadFilesInBatch(filesDataArray, folderName){
//       const documentLibraryName = "CLM365TaskAttachment"; // Replace with your document library name
//       const newFolderName = folderName; // The name of the new 
//       const token=localStorage.getItem("CurrentToken");
//       const createFolderUrl = `${ContextService.GetUrl()}/_api/web/lists/getbytitle('${documentLibraryName}')/rootfolder/folders`;
      
//       // Payload to specify the folder details
//       const folderPayload = {
//         "ServerRelativeUrl": `/sites/clm365test/${documentLibraryName}/${newFolderName}` // Adjust path as necessary
//       };
      
//       // Send the POST request to create the new folder
//       try {
//         const response = await axios.post(createFolderUrl, folderPayload, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             Accept: "application/json",
//             "Content-Type": "application/json"
//           }
//         });
      
//         console.log('Folder created successfully:', response.data);
//         if(response.data.ServerRelativeUrl){
//             const folderUrl = `${response.data.ServerRelativeUrl}`;

//             for (let i = 0; i < filesDataArray.length; i++) {
//                 const file = filesDataArray[i];
//                 const fileName=filesDataArray[i]?.GUID;
//                 const fileData = filesDataArray[i]?.FileContent;  // File object to send
              
//                 let finalTemplatelibrary = {
//                     TaskID: folderName,
//                     File_Name: filesDataArray[i]?.FileName,
//                     File_Guid:filesDataArray[i]?.GUID?.split('.')[0],
//                     AttachmentIntName:filesDataArray[i]?.IntName,
//                   };

//                 // Define the URL to upload the file to SharePoint
//                 const uploadFileUrl = `${ContextService.GetUrl()}/_api/web/getfolderbyserverrelativeurl('${folderUrl}')/files/add(overwrite=true, url='${fileName}')`;
              
//                 try {
//                   // Send the POST request to upload the file
//                   const uploadFileResponse = await axios.post(uploadFileUrl, fileData, {
//                     headers: {
//                       Authorization: `Bearer ${token}`,
//                       Accept: "application/json",
//                       "Content-Type": "application/octet-stream"  // Set content type to binary stream
//                     }
//                   });
//                   if (uploadFileResponse.data.ServerRelativeUrl) {
//                     const uploadedFileUrl = uploadFileResponse.data.ServerRelativeUrl;
//                     const updateMetadataUrl = `${ContextService.GetUrl()}/_api/web/getfilebyserverrelativeurl('${uploadedFileUrl}')/listitemallfields`;
//                     const getFileMetadataUrl = `${ContextService.GetUrl()}/_api/web/getfilebyserverrelativeurl('${uploadedFileUrl}')/listitemallfields`;

//                     const fileMetadataResponse = await axios.get(getFileMetadataUrl, {
//                       headers: {
//                         Authorization: `Bearer ${token}`,
//                         Accept: "application/json"
//                       }
//                     });

//                     const fileETag = fileMetadataResponse.headers['etag'];
//                     // Send the PATCH request to update metadata
//                     const updateMetadataResponse = await axios.patch(updateMetadataUrl, {
//                       TaskID: finalTemplatelibrary.TaskID,
//                       File_Name: finalTemplatelibrary.File_Name,
//                       File_Guid: finalTemplatelibrary.File_Guid,
//                       AttachmentIntName: finalTemplatelibrary.AttachmentIntName
//                     }, {
//                       headers: {
//                         Authorization: `Bearer ${token}`,
//                         Accept: "application/json",
//                         "Content-Type": "application/json",
//                         "If-Match": fileETag  
//                       }
//                     });

//                     if (updateMetadataResponse.status === 200) {
//                         console.log("File uploaded and metadata updated successfully.");
//                       } else {
//                         console.error("Failed to update metadata.");
//                       }
//                 }
              
//                   console.log(`File ${fileName} uploaded successfully:`, uploadFileResponse.data);
//                 } catch (error) {
//                   console.error(`Error uploading file ${fileName}:`, error);
//                 }
//               }
//         }

//       } catch (error) {
//         console.error('Error creating folder:', error);
//       }
      
// }

// export async function uploadFilesInBatch(filesDataArray, folderName) {
//   const documentLibraryName = "CLM365TaskAttachment"; // Replace with your document library name
//   const newFolderName = folderName; // The name of the new folder
//   const token = localStorage.getItem("CurrentToken");
//   const createFolderUrl = `${ContextService.GetUrl()}/_api/web/lists/getbytitle('${documentLibraryName}')/rootfolder/folders`;

//   // Payload to specify the folder details
//   const folderPayload = {
//       "ServerRelativeUrl": `/sites/clm365test/${documentLibraryName}/${newFolderName}` // Adjust path as necessary
//   };

//   // Send the POST request to create the new folder
//   try {
//       const response = await axios.post(createFolderUrl, folderPayload, {
//           headers: {
//               Authorization: `Bearer ${token}`,
//               Accept: "application/json",
//               "Content-Type": "application/json"
//           }
//       });

//       console.log('Folder created successfully:', response.data);
//       if (response.data.ServerRelativeUrl) {
//           const folderUrl = `${response.data.ServerRelativeUrl}`;

//           // Use Promise.all to upload files concurrently
//           const uploadPromises = filesDataArray.map(async (file) => {
//               const fileName = file?.GUID;
//               const fileData = file?.FileContent;  // File object to send

//               let finalTemplateLibrary = {
//                   TaskID: folderName,
//                   File_Name: file?.FileName,
//                   File_Guid: file?.GUID?.split('.')[0],
//                   AttachmentIntName: file?.IntName,
//               };

//               // Define the URL to upload the file to SharePoint
//               const uploadFileUrl = `${ContextService.GetUrl()}/_api/web/getfolderbyserverrelativeurl('${folderUrl}')/files/add(overwrite=true, url='${fileName}')`;

//               try {
//                   // Send the POST request to upload the file
//                   const uploadFileResponse = await axios.post(uploadFileUrl, fileData, {
//                       headers: {
//                           Authorization: `Bearer ${token}`,
//                           Accept: "application/json",
//                           "Content-Type": "application/octet-stream"  // Set content type to binary stream
//                       }
//                   });

//                   if (uploadFileResponse.data.ServerRelativeUrl) {
//                       const uploadedFileUrl = uploadFileResponse.data.ServerRelativeUrl;
//                       const updateMetadataUrl = `${ContextService.GetUrl()}/_api/web/getfilebyserverrelativeurl('${uploadedFileUrl}')/listitemallfields`;
//                       const getFileMetadataUrl = `${ContextService.GetUrl()}/_api/web/getfilebyserverrelativeurl('${uploadedFileUrl}')/listitemallfields`;

//                       const fileMetadataResponse = await axios.get(getFileMetadataUrl, {
//                           headers: {
//                               Authorization: `Bearer ${token}`,
//                               Accept: "application/json"
//                           }
//                       });

//                       const fileETag = fileMetadataResponse.headers['etag'];

//                       // Send the PATCH request to update metadata
//                       const updateMetadataResponse = await axios.patch(updateMetadataUrl, {
//                           TaskID: finalTemplateLibrary.TaskID,
//                           File_Name: finalTemplateLibrary.File_Name,
//                           File_Guid: finalTemplateLibrary.File_Guid,
//                           AttachmentIntName: finalTemplateLibrary.AttachmentIntName
//                       }, {
//                           headers: {
//                               Authorization: `Bearer ${token}`,
//                               Accept: "application/json",
//                               "Content-Type": "application/json",
//                               "If-Match": fileETag  
//                           }
//                       });

//                       if (updateMetadataResponse.status === 200) {
//                           console.log("File uploaded and metadata updated successfully.");
//                       } else {
//                           console.error("Failed to update metadata.");
//                       }
//                   }

//                   console.log(`File ${fileName} uploaded successfully:`, uploadFileResponse.data);
//               } catch (error) {
//                   console.error(`Error uploading file ${fileName}:`, error);
//               }
//           });

//           // Wait for all files to be uploaded
//           await Promise.all(uploadPromises);

//       }

//   } catch (error) {
//       console.error('Error creating folder:', error);
//   }
// }


export async function uploadFilesInBatch(filesDataArray, folderName) {
  const documentLibraryName = "CLM365TaskAttachment"; // Replace with your document library name
  const newFolderName = folderName; // The name of the new folder
  const token = localStorage.getItem("CurrentToken");
const siteUrl = localStorage.getItem("SiteURL");
 const siteName=siteUrl.split('/sites/')[1]||""

  const createFolderUrl = `${ContextService.GetUrl()}/_api/web/lists/getbytitle('${documentLibraryName}')/rootfolder/folders`;

  // Payload to specify the folder details
  let folderPayload;
  if(siteName.includes('/')){
     folderPayload = {
      "ServerRelativeUrl": `/sites/${siteName}${documentLibraryName}/${newFolderName}` // Adjust path as necessary
  };
  }else{
    folderPayload = {
      "ServerRelativeUrl": `/sites/${siteName}/${documentLibraryName}/${newFolderName}` // Adjust path as necessary
  };
  }


  // Send the POST request to create the new folder
  try {
      const response = await axios.post(createFolderUrl, folderPayload, {
          headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
              "Content-Type": "application/json"
          }
      });

      // console.log('Folder created successfully:', response.data);
      if (response.data.ServerRelativeUrl) {
          const folderUrl = `${response.data.ServerRelativeUrl}`;

          // Use Promise.all to upload files concurrently
          const uploadPromises = filesDataArray.map(async (file) => {
              const fileName = `${file?.GUID}`   //_${Date.now()}`;  // Make the file name unique using GUID and timestamp
              const fileData = file?.FileContent;  // File object to send

              let finalTemplateLibrary = {
                  TaskID: folderName,
                  File_Name: file?.FileName,
                  File_Guid: file?.GUID?.split('.')[0],
                  AttachmentIntName: file?.IntName,
              };

              // Define the URL to upload the file to SharePoint
              const uploadFileUrl = `${ContextService.GetUrl()}/_api/web/getfolderbyserverrelativeurl('${folderUrl}')/files/add(overwrite=true, url='${fileName}')`;

              try {
                  // Send the POST request to upload the file
                  const uploadFileResponse = await axios.post(uploadFileUrl, fileData, {
                      headers: {
                          Authorization: `Bearer ${token}`,
                          Accept: "application/json",
                          "Content-Type": "application/octet-stream"  // Set content type to binary stream
                      }
                  });

                  if (uploadFileResponse.data.ServerRelativeUrl) {
                      const uploadedFileUrl = uploadFileResponse.data.ServerRelativeUrl;
                      const updateMetadataUrl = `${ContextService.GetUrl()}/_api/web/getfilebyserverrelativeurl('${uploadedFileUrl}')/listitemallfields`;
                      const getFileMetadataUrl = `${ContextService.GetUrl()}/_api/web/getfilebyserverrelativeurl('${uploadedFileUrl}')/listitemallfields`;

                      const fileMetadataResponse = await axios.get(getFileMetadataUrl, {
                          headers: {
                              Authorization: `Bearer ${token}`,
                              Accept: "application/json"
                          }
                      });

                      const fileETag = fileMetadataResponse.headers['etag'];

                      // Send the PATCH request to update metadata
                      const updateMetadataResponse = await axios.patch(updateMetadataUrl, {
                          TaskID: finalTemplateLibrary.TaskID,
                          File_Name: finalTemplateLibrary.File_Name,
                          File_Guid: finalTemplateLibrary.File_Guid,
                          AttachmentIntName: finalTemplateLibrary.AttachmentIntName
                      }, {
                          headers: {
                              Authorization: `Bearer ${token}`,
                              Accept: "application/json",
                              "Content-Type": "application/json",
                              "If-Match": fileETag  
                          }
                      });

                      if (updateMetadataResponse.status === 200) {
                          console.log("File uploaded and metadata updated successfully.");
                      } else {
                          console.error("Failed to update metadata.");
                      }
                  }

                  // console.log(`File ${fileName} uploaded successfully:`, uploadFileResponse.data);
              } catch (error) {
                  console.error(`Error uploading file ${fileName}:`, error);
              }
          });

          // Wait for all files to be uploaded
          await Promise.all(uploadPromises);

      }

  } catch (error) {
      console.error('Error creating folder:', error);
  }
}




// export async function uploadExistFolderFilesInBatch(filesDataArray, folderName){
//     const documentLibraryName = "CLM365TaskAttachment"; // Replace with your document library name
//     const newFolderName = folderName; // The name of the new 
//     const token=localStorage.getItem("CurrentToken");

//     try {

//         const rootFolderUrl = `${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365TaskAttachment')/rootfolder`;
//         const response = await axios.get(rootFolderUrl, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             Accept: "application/json",
//           },
//         });

//         const rootFolder = response.data;

//       if(response.data.ServerRelativeUrl){
        
//           const folderUrl = `${response.data.ServerRelativeUrl}/${folderName}`;

//           for (let i = 0; i < filesDataArray.length; i++) {
//               const file = filesDataArray[i];
//               const fileName=filesDataArray[i]?.GUID;
//               const fileData = filesDataArray[i]?.FileContent;  // File object to send
//               let finalTemplatelibrary = {
//                 TaskID: folderName,
//                 File_Name: filesDataArray[i]?.FileName,
//                 File_Guid:filesDataArray[i]?.GUID?.split('.')[0],
//                 AttachmentIntName:filesDataArray[i]?.IntName,
//               };
//               // Define the URL to upload the file to SharePoint
//               const uploadFileUrl = `${ContextService.GetUrl()}/_api/web/getfolderbyserverrelativeurl('${folderUrl}')/files/add(overwrite=true, url='${fileName}')`;
            
//               try {
//                 // Send the POST request to upload the file
//                 const uploadFileResponse = await axios.post(uploadFileUrl, fileData, {
//                   headers: {
//                     Authorization: `Bearer ${token}`,
//                     Accept: "application/json",
//                     "Content-Type": "application/octet-stream"  // Set content type to binary stream
//                   }
//                 });
            
//                 console.log(`File ${fileName} uploaded successfully:`, uploadFileResponse.data);
//                 if (uploadFileResponse.data.ServerRelativeUrl) {
//                     const uploadedFileUrl = uploadFileResponse.data.ServerRelativeUrl;
//                     const updateMetadataUrl = `${ContextService.GetUrl()}/_api/web/getfilebyserverrelativeurl('${uploadedFileUrl}')/listitemallfields`;
//                     const getFileMetadataUrl = `${ContextService.GetUrl()}/_api/web/getfilebyserverrelativeurl('${uploadedFileUrl}')/listitemallfields`;

//                     const fileMetadataResponse = await axios.get(getFileMetadataUrl, {
//                       headers: {
//                         Authorization: `Bearer ${token}`,
//                         Accept: "application/json"
//                       }
//                     });

//                     const fileETag = fileMetadataResponse.headers['etag'];
//                     // Send the PATCH request to update metadata
//                     const updateMetadataResponse = await axios.patch(updateMetadataUrl, {
//                       TaskID: finalTemplatelibrary.TaskID,
//                       File_Name: finalTemplatelibrary.File_Name,
//                       File_Guid: finalTemplatelibrary.File_Guid,
//                       AttachmentIntName: finalTemplatelibrary.AttachmentIntName
//                     }, {
//                       headers: {
//                         Authorization: `Bearer ${token}`,
//                         Accept: "application/json",
//                         "Content-Type": "application/json",
//                         "If-Match": fileETag  
//                       }
//                     });

//                     if (updateMetadataResponse.status === 200) {
//                         console.log("File uploaded and metadata updated successfully.");
//                       } else {
//                         console.error("Failed to update metadata.");
//                       }
//                 }
//               } catch (error) {
//                 console.error(`Error uploading file ${fileName}:`, error);
//               }
//             }
//       }

//     } catch (error) {
//       console.error('Error creating folder:', error);
//     }
    
// }
export async function uploadExistFolderFilesInBatch(filesDataArray, folderName) {
  const documentLibraryName = "CLM365TaskAttachment"; // Replace with your document library name
  const token = localStorage.getItem("CurrentToken");

  try {
        // Define the root folder URL for the document library
    const rootFolderUrl = `${ContextService.GetUrl()}/_api/web/lists/getbytitle('${documentLibraryName}')/rootfolder`;
    const response = await axios.get(rootFolderUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    const rootFolder = response.data;

    if (rootFolder.ServerRelativeUrl) {
      // Construct the full folder URL based on the existing folder name
      const folderUrl = `${rootFolder.ServerRelativeUrl}/${folderName}`;

      // Loop through the files to upload them one by one
      try {
        await axios.get(
          `${ContextService.GetUrl()}/_api/web/getfolderbyserverrelativeurl('${folderUrl}')`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          }
        );
      } catch (error) {
        if (error.response?.status === 404) {
          await axios.post(
            `${ContextService.GetUrl()}/_api/web/folders`,
            {
              ServerRelativeUrl: folderUrl,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            }
          );
        } else {
          throw error;
        }
      }

      for (let i = 0; i < filesDataArray.length; i++) {
        const file = filesDataArray[i];
        const fileName = file?.GUID;
        const fileData = file?.FileContent;  // File content to upload

        // Define metadata for the file
        const finalTemplateLibrary = {
          TaskID: folderName,
          File_Name: file?.FileName,
          File_Guid: file?.GUID?.split('.')[0],
          AttachmentIntName: file?.IntName,
        };

        // URL to upload the file into the specified folder
        const uploadFileUrl = `${ContextService.GetUrl()}/_api/web/getfolderbyserverrelativeurl('${folderUrl}')/files/add(overwrite=true, url='${fileName}')`;

        try {
          // Send the POST request to upload the file
          const uploadFileResponse = await axios.post(uploadFileUrl, fileData, {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
              "Content-Type": "application/octet-stream",  // Set content type to binary stream
            },
          });

          //  console.log(`File ${fileName} uploaded successfully:`, uploadFileResponse.data);

          if (uploadFileResponse.data.ServerRelativeUrl) {
            const uploadedFileUrl = uploadFileResponse.data.ServerRelativeUrl;
            const updateMetadataUrl = `${ContextService.GetUrl()}/_api/web/getfilebyserverrelativeurl('${uploadedFileUrl}')/listitemallfields`;
            const getFileMetadataUrl = `${ContextService.GetUrl()}/_api/web/getfilebyserverrelativeurl('${uploadedFileUrl}')/listitemallfields`;

            // Get the metadata of the uploaded file
            const fileMetadataResponse = await axios.get(getFileMetadataUrl, {
              headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
              },
            });

            const fileETag = fileMetadataResponse.headers['etag'];

            // Send the PATCH request to update the metadata of the file
            const updateMetadataResponse = await axios.patch(updateMetadataUrl, {
                TaskID: finalTemplateLibrary.TaskID,
                File_Name: finalTemplateLibrary.File_Name,
                File_Guid: finalTemplateLibrary.File_Guid,
                AttachmentIntName: finalTemplateLibrary.AttachmentIntName,
              }, {
                headers: {
                  Authorization: `Bearer ${token}`,
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  "If-Match": fileETag,  // Use the ETag to prevent race conditions
                },
              });

            // if (updateMetadataResponse.status === 200) {
            //   console.log("File uploaded and metadata updated successfully.");
            // } else {
            //   console.error("Failed to update metadata.");
            // }
          }
        } catch (error) {
          console.error(`Error uploading file ${fileName}:`, error);
        }
      }
    }

  } catch (error) {
    console.error('Error fetching root folder or uploading files:', error);
  }
}



export const chunkArray = (arr, size) => {
    const results = [];
    for (let i = 0; i < arr.length; i += size) {
      results.push(arr.slice(i, i + size));
    }
    return results;
  };



  export  async  function updateDocumentAttachments(newData,documentTypeID) {
    const token = localStorage.getItem("CurrentToken");
    if (documentTypeID != "" && documentTypeID != null) {
      const updateurl =
        ContextService.GetUrl() +
        "/_api/web/lists/getbytitle('CLM365DocumentAttachment')/items('" +
        documentTypeID +
        "')";
       await axios
        .post(updateurl, {
          headers: {
            Accept: "application/json;odata=nometadata",
            "Content-type": "application/json;odata=nometadata",
            "odata-version": "",
            "IF-MATCH": "*",
            "X-HTTP-Method": "MERGE",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(newData),
        })

        .then((item: any) => {
          console.log("Item updated successfully");

        })
        .catch((error) => {
          console.error("Error occurred while updating item:", error);

        });
    } else {
        await axios
        .post(
          `${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365DocumentAttachment')/items`,
          {
            headers: {
              Accept: "application/json;odata=nometadata",
              "Content-type": "application/json;odata=nometadata",
              "odata-version": "",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(newData),
            
          }
        )

        .then((item: any) => {
            console.log("Item updated successfully");
  
          })
          .catch((error) => {
            console.error("Error occurred while updating item:", error);
  
          });
    }
  }



  export async function deleteFile(deletefilename) {
    const token = localStorage.getItem("CurrentToken");
    const url = `/_api/web/lists/getfolderbyserverrelativeurl('CLM365RequestDraft')/files/getbyname('${deletefilename}')`;
  
    try {
      const response = await axios.delete(`${ContextService.GetUrl()}${url}`, {
        headers: {
          Accept: "application/json;odata=nometadata", 
          "odata-version": "",                       
          Authorization: `Bearer ${token}`, 
        }
      });
      console.log(response)
      // Handle successful deletion
      console.log(`File '${deletefilename}' deleted successfully.`);
    //   return response.data;  // You can return any response data if needed
  
    } catch (error) {
      // Handle the error here
      console.error(`Error deleting file '${deletefilename}': `, error);
    }
  }
  
  export  function validateApproval(datatype, actualdata, condition, fieldValue) {
    var regExp = /[a-zA-Z]/g;
    let returnflag = false;
    if (datatype == "Text") {
      if (!regExp.test(fieldValue) && !regExp.test(actualdata)) {
        actualdata = parseInt(actualdata) ? parseInt(actualdata) : actualdata;
        fieldValue = parseInt(fieldValue);
      }
    } else if (datatype == "Date") {
      actualdata = moment(actualdata).format("YYYYMMDD")
        ? moment(actualdata).format("YYYYMMDD")
        : actualdata;
      fieldValue = moment(fieldValue).format("YYYYMMDD")
        ? moment(fieldValue).format("YYYYMMDD")
        : fieldValue;
    } else if (datatype == "Number") {
      actualdata = parseInt(actualdata) ? parseInt(actualdata) : actualdata;
      fieldValue = parseInt(fieldValue);
    }
    switch (condition) {
      case "Equal to":
        actualdata == fieldValue ? (returnflag = true) : returnflag;
        break;
      case "Less than":
        actualdata < fieldValue ? (returnflag = true) : returnflag;
        break;
      case "Greater than":
        actualdata > fieldValue ? (returnflag = true) : returnflag;
        break;
      case "Less than equal":
        actualdata <= fieldValue ? (returnflag = true) : returnflag;
        break;
      case "Greater than equal":
        actualdata >= fieldValue ? (returnflag = true) : returnflag;
        break;
    }
    return returnflag;
  }




  export const getActivityData = async () => {
    const token = localStorage.getItem("CurrentToken");
    const activityURL = `/_api/web/lists/getbytitle('CLM365General')/items?$select=ID,BusinessUnit,Activity,Role&$filter=Title eq 'GeneralData'`;
  
    try {
      const response = await axios.get(`${ContextService.GetUrl()}${activityURL}`, {
        headers: {
          Accept: "application/json;odata=nometadata",
          "odata-version": "",
          Authorization: `Bearer ${token}`,
        },
      });
  
      const items = response?.data?.value || [];

      if (items.length > 0 && items[0]?.Activity) {
        const Activity = JSON.parse(items[0]?.Activity);
        return Activity || finalactivitydata;
      } else {
        return finalactivitydata; 
      }
    } catch (error) {
      console.error("Error fetching activity data:", error);
      return finalactivitydata; 
    }
  };
  

export const getAIAgentData = async (
  currentUserGuid: string,
  SessionID?: string
): Promise<any[]> => {
  try {
    const token = localStorage.getItem("CurrentToken");
    if (!token) throw new Error("Access token not found in localStorage");

    let getQuery = "";

    if (SessionID) {
      getQuery = `${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365AIAgent')/Items?$select=*&$filter=UserGUID eq guid'${currentUserGuid}' and SessionID eq guid'${SessionID}'`;
    } else {
      getQuery = `${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365AIAgent')/Items?$select=*&$filter=UserGUID eq guid'${currentUserGuid}'`;
    }

    const response = await axios.get(getQuery, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json;odata=nometadata",
        "odata-version": "",
      },
    });

    return response.data?.value || [];
  } catch (error) {
    console.error("Error in getAIAgentData:", error);
    return [];
  }
};


export const postAIAgentData = async (
  finalTemplate: any,
) => {
  const token = localStorage.getItem("CurrentToken");
  if (!token) throw new Error("Access token not found in localStorage");

  const existingItems = await getAIAgentData(finalTemplate?.UserGUID, finalTemplate?.SessionID);

  if (existingItems.length) {
    const itemId = existingItems[0].Id;
    const updateUrl = `${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365AIAgent')/items(${itemId})`;

    const filteredTemplate = {
      Messages: finalTemplate.Messages,
      SessionID: finalTemplate?.SessionID,
      UserGUID: finalTemplate?.UserGUID,
    };

    const updateResponse = await axios.post(updateUrl, filteredTemplate, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json;odata=nometadata",
        "Content-type": "application/json;odata=nometadata",
        "odata-version": "",
        "IF-MATCH": "*",
        "X-HTTP-Method": "MERGE",
      },
    });

    if (updateResponse.status !== 204) {
      throw new Error(`Update failed with status: ${updateResponse.status}`);
    }
  } else {
    const url = `${ContextService.GetUrl()}/_api/web/lists/getbytitle('CLM365AIAgent')/items`;

    const createResponse = await axios.post(url, {
      ...finalTemplate,
      SessionID: finalTemplate?.SessionID,
      UserGUID: finalTemplate?.UserGUID,
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json;odata=nometadata",
        "Content-type": "application/json;odata=nometadata",
        "odata-version": "",
      },
    });

    if (!(createResponse.status === 200 || createResponse.status === 201)) {
      throw new Error(`Create failed with status: ${createResponse.status}`);
    }
 
    return createResponse.data;
  }
};

export function CalcuateBusinessDays(dueDays, validDays) {
  const dayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  const DueDaysSelected = parseInt(dueDays);
  const validDayIndex = validDays.map(day => dayMap[day]);
  let Dayscount = 0;
  let TaskEndDate = new Date();
  TaskEndDate.setDate(TaskEndDate.getDate() + 1);

  while (Dayscount < DueDaysSelected) {
    const dayIndex = TaskEndDate.getDay();
    if (validDayIndex.includes(dayIndex)) {
      Dayscount++;
      if (Dayscount === DueDaysSelected) break;
    }
    TaskEndDate.setDate(TaskEndDate.getDate() + 1);
  }

  return TaskEndDate;
}